import { AboutUs } from '@/features/homepage/components/about-us';
import { Hero } from '@/features/homepage/components/hero';
import { Overview } from '@/features/homepage/components/overview';
import { Philosophy } from '@/features/homepage/components/philosophy';
import { Programs } from '@/features/homepage/components/programs';

export function HomePage() {
  // @TODO: set direction based on the language
  return (
    <>
      <Hero />
      <Overview />
      <Programs />
      <Philosophy />
      <AboutUs />
    </>
  );
}
